/* eslint-disable */

import React from 'react';
import { getIconColor } from './helper';

const DEFAULT_STYLE = {
  display: 'block',
};

const IconPinggugongzuokaizhanqingkuang = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M846.528 923.328H177.472a36.032 36.032 0 0 1-35.84-35.84c0-18.816 15.36-35.84 35.84-35.84h669.056c18.752 0 35.84 15.36 35.84 35.84 0 18.752-15.36 35.84-35.84 35.84z m73.344-822.656H104.128c-37.568 0-70.016 32.448-70.016 71.68v530.816c0 39.232 32.448 69.952 70.016 69.952h814.08c39.232 0 69.952-32.448 69.952-69.952V172.352a69.248 69.248 0 0 0-68.288-71.68zM273.088 571.712c0 18.816-15.36 35.84-35.84 35.84-20.48 0-35.84-15.36-35.84-35.84v-133.12c0-18.752 15.36-35.84 35.84-35.84 20.48 0 35.84 15.36 35.84 35.84v133.12z m182.592 0c0 18.816-15.36 35.84-35.84 35.84a36.032 36.032 0 0 1-35.84-35.84v-240.64c0-18.752 15.36-35.84 35.84-35.84 18.752 0 35.84 15.36 35.84 35.84v240.64z m182.592 0c0 18.816-15.36 35.84-35.84 35.84a36.032 36.032 0 0 1-35.84-35.84V360.128c0-18.816 15.36-35.84 35.84-35.84 18.816 0 35.84 15.36 35.84 35.84v211.584z m184.32 0c0 18.816-15.36 35.84-35.84 35.84-20.48 0-35.84-15.36-35.84-35.84V286.72c0-18.752 15.36-35.84 35.84-35.84 20.48 0 35.84 15.36 35.84 35.84v284.992z"
        fill={getIconColor(color, 0, '#FFFFFF')}
      />
    </svg>
  );
};

IconPinggugongzuokaizhanqingkuang.defaultProps = {
  size: 18,
};

export default IconPinggugongzuokaizhanqingkuang;
